import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Paragraph from '../../Paragraph/Paragraph';
import Modal from '../../Modal';
import ButtonPrimary from '../../Buttons/Button';
import themeColors from '../../../assets/styles/themeColors';
import { EVENT_TYPES_ENUM } from '../../../util/enum/api/crmEvents';
import useApplicationUid from '../../../hooks/useApplicationUid';
import { removeFromSessionStorage } from '../../../util/helpers/sessionStorageHelper';
import { CONTENT_TYPE } from '../../../constants/sessionStorage';

const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px 10px;
  align-items: center;
  @media only screen and (max-width: 750px) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 10px 10px;
    margin-top: auto;
    margin-bottom: 24px;
  }
`;

export const ContinueRegistrationLink = styled.button`
  all: unset;
  cursor: pointer;
  padding-left: 4px;
  color: ${themeColors.colorTextSecondary};
  font-weight: 600;
`;

const ExitConfirmationModal = ({
  isOpen,
  onClose,
  saveAndExit,
  handleCrmEvent,
  registrationUrl,
}) => {
  const { t } = useTranslation();

  const appUid = useApplicationUid();
  const [exit, setExit] = useState(false);
  const [crmEventDone, setCrmEventDone] = useState(false);

  useEffect(() => {
    if (crmEventDone) {
      if (exit) {
        saveAndExit();
      } else {
        onClose();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [crmEventDone, exit]);

  const onCrmEventPosted = () => {
    setCrmEventDone(true);
  };

  const onSaveAndExit = (exit) => {
    setExit(exit);
    if (exit) {
      removeFromSessionStorage(CONTENT_TYPE);
    }
    handleCrmEvent(
      appUid?.ApplicationUid,
      {
        RegistrationPageUrl: registrationUrl,
        ExitModalType: exit ? EVENT_TYPES_ENUM.Save : EVENT_TYPES_ENUM.Continue,
      },
      onCrmEventPosted,
      onCrmEventPosted,
    );
  };

  return (
    <Modal
      variant="lg"
      isOpen={isOpen}
      onClose={onClose}
      label={t('exitConfirmation.title')}
      removeCloseIcon
      dismissOnClickOutside
    >
      <Paragraph color={themeColors.colorTextXLLight} mb={28}>
        {t('exitConfirmation.cta')}
      </Paragraph>
      <ButtonGroup>
        <ButtonPrimary
          onClick={() => onSaveAndExit(true)}
          title={t('exitConfirmation.saveExit')}
        />
        <ContinueRegistrationLink onClick={() => onSaveAndExit(false)}>
          {t('exitConfirmation.continueRegistration')}
        </ContinueRegistrationLink>
      </ButtonGroup>
    </Modal>
  );
};

ExitConfirmationModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  saveAndExit: PropTypes.func,
  handleCrmEvent: PropTypes.func,
  registrationUrl: PropTypes.string,
};

export default ExitConfirmationModal;
